import { render } from "./DobDialogV1.vue?vue&type=template&id=3ea7d392&scoped=true"
import script from "./DobDialogV1.vue?vue&type=script&lang=js"
export * from "./DobDialogV1.vue?vue&type=script&lang=js"

import "./DobDialogV1.vue?vue&type=style&index=0&id=3ea7d392&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea7d392"]])

export default __exports__